import { baseApi } from "./baseApi";
const INCIDENT_REPORT_BASE_URL = "/incident-report";

export const incidentReportApi = baseApi.injectEndpoints({
  tagTypes: ["IncidentReport"],

  endpoints: (build) => ({
    addIncidentReport: build.mutation({
      query: (body) => ({
        url: INCIDENT_REPORT_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "IncidentReport", id: "LIST" }],
    }),
    listIncidentReports: build.query({
      query: (params) => ({
        url: INCIDENT_REPORT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.invalidatesTags
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "IncidentReport, _id",
                // id: _id,
              })),
              { type: "IncidentReport", id: "LIST" },
            ]
          : [{ type: "IncidentReport", id: "LIST" }],
    }),
    getDDLIncidentReportList: build.query({
      query: (params) => ({
        url: `${INCIDENT_REPORT_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({
                type: "IncidentReport",
                id,
              })),
              { type: "IncidentReport", id: "DDL" },
            ]
          : [{ type: "IncidentReport", id: "DDL" }],
    }),
    getIncidentReportDetail: build.query({
      query: (incidentId) => `${INCIDENT_REPORT_BASE_URL}/${incidentId}`,
      providesTags: (result, error, { _id }) => [
        { type: "IncidentReport", id: _id },
        { type: "IncidentReport", id: "LIST" },
      ],
    }),
    updateIncidentReport: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${INCIDENT_REPORT_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "IncidentReport", id },
        { type: "IncidentReport", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListIncidentReportsQuery,
  useLazyListIncidentReportsQuery,
  useAddIncidentReportMutation,
  useLazyGetDDLIncidentReportListQuery,
  useGetIncidentReportDetailQuery,
  useUpdateIncidentReportMutation,
} = incidentReportApi;
